// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"647":"component---src-pages-markdown-remark-frontmatter-slug-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"647":"01d88a5f310c0513e4fb","678":"2a375bc68b778b826b29"}[chunkId] + ".js";
};